import { jwtDecode } from 'jwt-decode';

export const parseDocDate = (dateStr: string) => {
    if (!dateStr) return null;
    const parts = dateStr.split('.');
    if (parts.length !== 3) return null;
    
    const day = parseInt(parts[0]);
    const month = parseInt(parts[1]);
    const year = parseInt(parts[2]);

    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    if (year < 1000) return null; // Simple year check (e.g. 2023)
    if (month < 1 || month > 12) return null;
    if (day < 1 || day > 31) return null;

    return new Date(year, month - 1, day);
};

export const verifyLicense = (licenseText: string, currentTime: number = Date.now()): boolean => {
    try {
        if (!licenseText || licenseText.length === 0) return false;
        
        const decoded: any = jwtDecode(licenseText);
        
        if (decoded && decoded.exp) {
            return (decoded.exp * 1000) > currentTime;
        } else if (decoded && decoded.startDate && decoded.endDate) {
            const start = parseDocDate(decoded.startDate);
            const end = parseDocDate(decoded.endDate);
            
            // Calculate expected iat based on days
            const startDay = parseInt(decoded.startDate.split('.')[0]);
            const endDay = parseInt(decoded.endDate.split('.')[0]);
            const expectedIat = startDay * endDay;

            if (start && end && 
                currentTime >= start.getTime() && 
                currentTime <= end.getTime() && 
                decoded.iat === expectedIat) {
                return true;
            }
        }
    } catch (e) {
        console.error("License verification error:", e);
    }
    return false;
};
